export enum GroupMessageSmsStatusesEnum {
  NotSent = 0,
  Sent = 1,
  Delivered = 2,
  Failed = 3,
}
